import { render, staticRenderFns } from "./SettingsVatRate.vue?vue&type=template&id=72946a3a&scoped=true&"
import script from "./SettingsVatRate.vue?vue&type=script&lang=js&"
export * from "./SettingsVatRate.vue?vue&type=script&lang=js&"
import style0 from "./SettingsVatRate.vue?vue&type=style&index=0&id=72946a3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72946a3a",
  null
  
)

export default component.exports